export const Perfil = {
  "Meu Perfil": "Mi Perfil",
  "Código": "Código",
  "Alterar senha": "Cambiar contraseña",
  "Sair": "Cerrar sesión",
  "Dados Pessoais": "Datos Personales",
  "Email:": "Correo electrónico:",
  "Função:": "Función:",
  "Turno:": "Turno:",
  "Contato": "Contacto",
  "Adicionar Whatsapp": "Añadir Whatsapp",
  "Dados da Empresa": "Datos de la Empresa",
  "Nome:": "Nombre:",
  "Data de admissão:": "Fecha de admisión:",
  "Telefone:": "Teléfono:",
  "Visualizar LinkedIn": "Ver LinkedIn",
  "Adicionar LinkedIn": "Añadir LinkedIn",
  "Tivemos um problema com a conexão. Tente novamente atualizando a página.": "Tuvimos un problema con la conexión. Intente nuevamente actualizando la página.",
  "Aviso": "Aviso",
  "Não foi possivel realizar o envio da imagem. Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.": "No fue posible realizar el envío de la imagen. Motivo: archivo muy grande por favor enviar un archivo menor que 2MB."
};


// WEBPACK FOOTER //
// ./src/resources/es/Perfil.js